'use strict';

var simpleClone = require('./simpleClone'),
    defineAccessor = require('./defineAccessor');

function defineOptionsAccessor(namespace, defaults) {
  var obj = simpleClone(defaults);

  function getOption(name) {
    return obj[name];
  }

  function setOption(name, val) {
    if (val === null) {
      val = defaults[name];
    }
    obj[name] = val;
  }

  defineAccessor(namespace, 'getOption', getOption);
  defineAccessor(namespace, 'setOption', setOption);
  return getOption;
}

module.exports = defineOptionsAccessor;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/defineOptionsAccessor.js
// module id = 113
// module chunks = 0